<div class="checkmark-list">
  <div *ngFor="let entry of entries" class="checkmark-list__entry d-flex flex-nowrap">
    <div class="checkmark-list__entry__icon d-flex justify-content-center align-items-center me-2">
      <ng-container *ngIf="useBoxIcon; else checkmarkIcon">
        <em class="box-icon"></em>
      </ng-container>
      <ng-template #checkmarkIcon>
        <em class="ds-icon--checked ds-color--black"></em>
      </ng-template>
    </div>
    <div class="d-flex flex-column ds-body">
      <span *ngIf="entry.name" class="fw-bold ds-color--black">{{entry.name}}</span>
      <span [innerHTML]="entry.value"></span>
    </div>
  </div>
</div>
